import { Component } from '@angular/core';
import { LoadingService } from './loading.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-loader',
  imports: [AsyncPipe],
  template: `
    @if (loadingService.loading$ | async) {
      <div class="loader-container">
        <div class="spinner"></div>
        <p>Carregando...</p>
      </div>
    }

  `,
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent {
  constructor(public loadingService: LoadingService) {}
}

